import AccountabilityIcon from "assets/images/accountability_icon.svg";
import ReduceCostIcon from "assets/images/reduce-cost.svg";
import MobileIcon from "assets/images/mobile-icon.svg";
import SmartCountIcon from "assets/images/smart-count.svg";
import RiskReducedIcon from "assets/images/risk-reduced.svg";
import MultiUserIcon from "assets/images/multi-user.svg";

export default function WhyChooseLottoRecoSection() {
    return (<section className="features-section">
        <div className="whyChoose-scroll-element"></div>
        <h2 className="features-title">Why Convenience Stores Choose LottoReco for Lottery Reconciliation</h2>
        <div className="custom-container d-flex items-center width-100">
        <div className="features-grid">
            <div className="feature-card">
                <img
                className="feature-icon"
                src={AccountabilityIcon}
                alt="Reconciliation Icon "
                />
                <div>
                    <h3>Cut Reconciliation Time by 80%</h3>
                    <p>No more manual tallying – just take a picture and get instant results. Say goodbye to 45-minute closings; say hello to 5-minute wrap-ups.</p>
                </div>
            </div>
            <div className="feature-card">
                <img
                className="feature-icon"
                src={ReduceCostIcon}
                alt="Eliminate Costly Icon "
                />
                <div>
                    <h3>Eliminate Costly Errors</h3>
                    <p>Human errors happen – a "6" looked like an "8" on paper. LottoReco's automated tracking means precise counts every time with alerts for discrepancies.</p>
                </div>
            </div>
            <div className="feature-card">
                <img
                className="feature-icon"
                src={MobileIcon}
                alt="Mobile Icon "
                />
                <div>
                    <h3>Mobile & Easy to Use</h3>
                    <p>Our free mobile app works on any smartphone. If you can take a photo, you can use LottoReco – no complicated software or training required.</p>
                </div>
            </div>
            <div className="feature-card">
                <img
                className="feature-icon"
                src={SmartCountIcon}
                alt="SmartCount Icon "
                />
                <div>
                    <h3>SmartCount Integrated</h3>
                    <p>Already using California's SmartCount? We work with it, not against it. Simply print your report, snap a photo, and all data is imported automatically.</p>
                </div>
            </div>
            <div className="feature-card">
               <img
                className="feature-icon"
                src={RiskReducedIcon}
                alt="Risk Reduced Icon "
                />
                <div>
                    <h3>Theft Risk Reduced</h3>
                    <p>Enjoy peace of mind knowing every ticket is accounted for. LottoReco immediately flags any discrepancies between sales, inventory, and state records.</p>
                </div>
            </div>
            <div className="feature-card">
                <img
                className="feature-icon"
                src={MultiUserIcon}
                alt="Multi User Icon "
                />
                <div>
                    <h3>Multi-User Support</h3>
                    <p>Invite staff members with different roles (owner, manager, operator). Each user gets appropriate permissions and access levels.</p>
                </div>
            </div>
        </div>
    </div>
    </section>
    );
}